import React from 'react';

export default ({svg})=> (
	<span className='Icon' aria-hidden='true' dangerouslySetInnerHTML={{__html: svg}}/>
);